<template>
  <section class="main">
    <h1 class="intro">{{ $t("HOW_TO_UNLINK") }}</h1>

    <div class="content">
      <p class="g-text" v-html="$t('UNLINK_DESCRIPTION')"></p>
      <v-button size="lg" type="negative" :loading="isUnlinkingDevice" @click="unlinkDevice">
        {{ $t('UNLINK_DEVICE_BUTTON_LABEL') }}
      </v-button>
    </div>
    <br /><br />
    <h1 class="intro">{{ $t("UNLINK_YOUR_BROWSER") }}</h1>
    <div class="content">
      <p class="g-text">
        {{ $t("IT_WILL_ALSO_BE_UNLINKED") }}
      </p>
      <v-button size="lg" type="negative" @click="unlinkPc">
        {{ $t("UNLINK") }}
      </v-button>
    </div>
  </section>
</template>

<script>
import { mapActions } from 'vuex';
import VButton from '@/components/Button';

export default {
  components: {
    VButton,
  },
  data() {
    return {
      isUnlinkingDevice: false,
    };
  },
  computed: {
    title() {
      return this.$t('HOW_TO_UNLINK');
    },
  },
  methods: {
    ...mapActions(['clearLinkedDeviceData']),
    async unlinkDevice() {
      if (this.isUnlinkingDevice) {
        return;
      }

      await this.$confirm(this.$t('UNLINK_DEVICE_CONFIRMATION'), { okText: this.$t('YES') });

      this.isUnlinkingDevice = true;
      try {
        await this.$api.notifyProfileRemoval();
        localStorage.removeItem('old_lt');
        this.unlinkPc();
      } finally {
        this.isUnlinkingDevice = false;
      }
    },
    unlinkPc() {
      this.clearLinkedDeviceData();
      this.$router.push('/');
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/variables";

.main {
  display: block;
  flex-grow: 1;
}

.content {
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: flex-start;
}
</style>
